import { render } from "./Icon.vue?vue&type=template&id=1fb3e4b8"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pedropuga/Documents/ITSON/ITSON-BACKEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__